export const API_ASSETS_ROUTE = 'https://d23e8cijo99k6w.cloudfront.net/SZWF';
export const strapiAssetBaseUrl =
  'https://strapi-ecm-assets.s3.ap-southeast-1.amazonaws.com';
